import { render } from "./TemplateDefault.vue?vue&type=template&id=36d6c036&scoped=true"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"

import "./TemplateDefault.vue?vue&type=style&index=0&id=36d6c036&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d6c036"]])

export default __exports__